// extracted by mini-css-extract-plugin
export default {"body":"delete_certificate_modal-module___body___ab7beb71"};